import React, { useEffect, useMemo, useRef, useReducer, useState } from "react";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { Tooltip } from "../../components/utils/Tooltip";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { BotonExportarExcel } from "../../components/buttons/BotonExportarExcel";
import { BotonGeneral } from "../../components/buttons/BotonGeneral";
import { Modal } from "../../components/modal/Modal";
import { useModal } from "../../../hooks/useModal";
import { SearchTable } from "../../components/utils/SearchTable";
import { DatePickerABX } from "../../components/pickers/DatePicker";
import { useMovimientos } from "../../../hooks/almacen/useMovimientos";
import { capitalLetter, classNameInput, dateToString, formatDate, notify, stringToDate } from "../../../utils/utils";
import { useKardex } from "../../../hooks/reportes/useKardex";
import { AutoComplete } from "../../components/forms/AutoComplete";
import { useBloqueoPantalla } from "../../../hooks/useBloqueoPantalla";
import { AutoCompleteV2 } from "../../components/forms/AutoCompleteV2";
import { useRepuestos } from "../../../hooks/registros/useRepuestos";
import { useUnidades } from "../../../hooks/gestionMantenimientos/useUnidades";
import { useSettings } from "../../../hooks/gestionMantenimientos/useSettings";
import { useNeumaticos } from "../GestionNeumaticos/useNeumaticos";
import { useSalidaTraslado } from "../../../hooks/almacen/useSalidaTraslado";
import { useProductos } from "../../../hooks/almacen/useProductos";
import { useIngresoTraslado } from "../../../hooks/almacen/useIngresoTraslado";

export const Movimientos = () => {
    const movimientoInfoDefault = {
        codOrdenTrabajo: 0,
        codDiagnosticoTaller: 0,
        fechaOrdenTrabajo: "",
        codDocumento: 0,
        numDocumentoOT: "",
        codUnidad: 0,
        unidad: "",
        codPersonaConductor: 0,
        nomPersonaConductor: "",
        codEstado: 0,
        nomEstado: "",
        codUsuarioCreacion: 0,
        nomUsuarioCreacion: "",
        repuestoDetalle: "",

        comentario: "",
        codSolicitante: 0,
    };
    const estadosSalidaOrdenTrabajo = {
        9: "bg-orange-600", // PENDIENTE
        18: "bg-gray-600", // ATENDIDO
        37: "bg-[#5cb85c]", // AUTORIZADO
        39: "bg-[#c0c0c0]", // FINALIZADO
    };

    const {
        listarIngresoInventario,
        ingresosInventario,
        listarDiagnosticoTaller,
        diagnosticosTaller,
        movimientoDefault,
        listarTipoDeMovimientos,
        tipoMovimientos,
        listarAlmacenes,
        almacenes,
        listarEstadosMovimiento,
        estadosMovimiento,
        registrarIngresoInventario,
        personasTaller,
        listarComboPersonasTaller,
        registrarSalidaPorOT,
        anularSalidaPorTraslado,
        listarAlmacenesPorUsuario,
        almacenesPorUsuario
    } = useMovimientos();

    const { unidadesActivas, listadoUnidadesActivas } = useUnidades();
    const { listarConductores, conductores } = useSettings();
    const { listarRepuestos, repuestos } = useRepuestos();
    const { autocompleteProductos, productos } = useKardex();
    const {
        listarRepuestoCodigos, // OBTIENE LAS SERIES DE LOS NEUMATICOS (SOLO LOS NEUMATICOS TIENEN SERIE¿¿¿)
        repuestosCodigos,
    } = useNeumaticos();

    const [isOpen, openModal, closeModal] = useModal();
    const [isOpenSeries, openModalSeries, closeModalSeries] = useModal();
    const [isOpenDetallado, openModalDetallado, closeModalDetallado] =
        useModal();
    const [isOpenSalidaOT, openSalidaOT, closeSalidaOT] = useModal();
    const [isOpenModalAnularSalida,openModalAnularSalida,closeModalAnularSalida] = useModal()
    const [
        isOpenModalSeriesSalida,
        openModalSeriesSalida,
        closeModalSeriesSalida,
    ] = useModal();
    const [bloquearPantalla, desbloquearPantalla, ComponenteBloqueo] =
        useBloqueoPantalla();

    const [startDate, setStartDate] = useState(() => {
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 30);
        return sevenDaysAgo;
    });
    const [endDate, setEndDate] = useState(new Date());
    const [movimientoSeleccionado, setMovimientoSeleccionado] = useState(1);
    const [almacenSeleccionado, setAlmacenSeleccionado] = useState(1);
    const [estadoSeleccionado, setEstadoSeleccionado] = useState(0);
    const [parametrosProcesar, setParametrosProcesar] = useState({
        movimientoSeleccionado: 0,
    });
    const [codigoProdSeleccionadoSerie, setCodigoProdSeleccionadoSerie] =
        useState(0);
    const [cantidadProductosSeries, setCantidadProductosSeries] = useState(0);
    const [filasTablaIngresoInventario, setFilasTablaIngresoInventario] =
        useState([]);
    const [detalleMovimiento, setDetalleMovimiento] = useState([]);
    const [movimientoInfo, setMovimientoInfo] = useState(movimientoInfoDefault);
    const [seriesModalSalida, setSeriesModalSalida] = useState({});

    // SALIDA POR TRASLADO ALMACEN
    const [isOpenModalSalida,openModalSalida,closeModalSalida] = useModal()
    const [almacenOrigen,setAlmacenOrigen] = useState(0)
    const [almacenDestino,setAlmacenDestino] = useState(0)
    const productoDefault = {
        codProducto: 0,
        serieProducto: false,
        cantidadProducto: 0,
        listaSeries: []
    }
    const [arrProductos,setArrProductos] = useState([productoDefault])
    const [comentarioSalida,setComentarioSalida] = useState('')
    const [comentarioAnulacionSalida,setComentarioAnulacionSalida] = useState('')
    const [codigoSalidaTraslado,setCodigoSalidaTraslado] = useState(0)
    // -- 

    // MODAL DE SERIES
    const [indiceProducto,setIndiceProducto] = useState(0)
    const [isOpenModalSeriesMovimiento,openModalSeriesMovimiento,closeModalSeriesMovimiento] = useModal()
    const [seriesMovimiento,setSeriesMovimientos] = useState([])
    // --

    // INGRESO TRASLADO ALMACEN
    const {
        listarIngresoPorTraslado,
        listaIngresos,

        listarInfoMovimiento,

        obtenerUltimoDocumentoIngreso,
        ultimoDocumentoIngreso,

        registrarIngresoPorTrasladoAlmacen
    } = useIngresoTraslado()
    const [infoPreIngresoAlmacen,setInfoPreIngresoAlmacen] = useState({})
    // --

    const {
        listarSalidasPorTraslado,
        listadoSalidasPorTraslado,

        obtenerUltimoDocumentoSalida,
        ultimoDocumentoSalida,

        anularTransferencia,

        registrarSalidaPorTraslado,
        salidaTrasladoAlmacen,
        setSalidaTrasladoAlmacen,
        salidaDefault,
        editarValorSalidaTraslado
    } = useSalidaTraslado()
    const {listaProductos,listarProductos,setListaProductos} = useProductos()

    useEffect(() => {
        (async () => {
            bloquearPantalla();
            await listarComboPersonasTaller();
            await listadoUnidadesActivas();
            await listarConductores();
            await listarTipoDeMovimientos();
            await listarAlmacenes();
            await listarAlmacenesPorUsuario()
            await listarEstadosMovimiento();
            await autocompleteProductos("", almacenSeleccionado);
            desbloquearPantalla();
        })();
    }, []);

    useEffect(() => {
        funcionListarTabla();
    },[movimientoSeleccionado,startDate,endDate,almacenSeleccionado,estadoSeleccionado])

    const editarValorMovimientoInfo = (key, value) => {
        setMovimientoInfo((valorAnterior) => {
            return {
                ...valorAnterior,
                [key]: value,
            };
        });
    };

    const editarCantidadFilasTablaInventario = (codigoRepuesto, cantidad) => {
        const arrayTemporal = [...filasTablaIngresoInventario];
        const objetoModificar = arrayTemporal.find(
            (e) => e.codRepuesto == codigoRepuesto
        );
        const objetoModificado = { ...objetoModificar };
        objetoModificado.cantidadProductos = cantidad;
        const indiceProductoModificado = arrayTemporal.findIndex(
            (e) => e.codRepuesto == codigoRepuesto
        );
        arrayTemporal[indiceProductoModificado] = objetoModificado;
        setFilasTablaIngresoInventario(arrayTemporal);
    };

    const agregarSeriesAProducto = (codigoRepuesto, indice, valor) => {
        const arrayTemporal = [...filasTablaIngresoInventario];
        const objetoModificar = arrayTemporal.find(
            (e) => e.codRepuesto == codigoRepuesto
        );
        const objetoModificado = { ...objetoModificar };
        objetoModificado.seriesGuardadas[indice] = valor.trim();
        const indiceProductoModificado = arrayTemporal.findIndex(
            (e) => e.codRepuesto == codigoRepuesto
        );
        arrayTemporal[indiceProductoModificado] = objetoModificado;
        setFilasTablaIngresoInventario(arrayTemporal);
    };

    const funcionListarTabla = async () => {
        setParametrosProcesar({
            movimientoSeleccionado: movimientoSeleccionado,
        });
        bloquearPantalla()
        switch (Number(movimientoSeleccionado)) {
            case 1: //Ingreso por inventario
                await listarIngresoInventario(
                    formatDate(startDate),
                    formatDate(endDate)
                );
                break;
            case 10: //Salida por orden de trabajo
                await listarDiagnosticoTaller(
                    formatDate(startDate),
                    formatDate(endDate),
                    estadoSeleccionado
                );
                break;
            case 7: //Ingreso por traslado almacen
                await listarIngresoPorTraslado(dateToString(startDate),dateToString(endDate))
                break;
            case 6: //Salida por traslado almacen
                await listarSalidasPorTraslado({
                    fechaInicio: dateToString(startDate),
                    fechaFin: dateToString(endDate)
                })
                break;
            default:
                notify("Seleccionar un tipo de movimiento", "info");
                break;
        }
        desbloquearPantalla()
    };
    const funcionAgregarElemento = (codigoElemento) => {
        if (codigoElemento != 0) {
            if (
                !filasTablaIngresoInventario.some(
                    (e) => e.codRepuesto == codigoElemento
                )
            ) {
                let productoElegido = productos.find(
                    (e) => e.codRepuesto == codigoElemento
                );
                productoElegido = {
                    ...productoElegido,
                    seriesGuardadas: [],
                    cantidadProductos: 0,
                };

                setFilasTablaIngresoInventario([
                    ...filasTablaIngresoInventario,
                    productoElegido,
                ]);
            } else {
                notify("Este repuesto ya esta seleccionado", "info");
            }
        }
    };
    const funcionRegistroMovimiento = async () => {
        const objetoEnvio = filasTablaIngresoInventario.map((data, i) => {
            return {
                codRepuesto: data.codRepuesto,
                registraSerieRespuesto: data.registraSerie,
                cantidad: data.cantidadProductos,
                parametroSerie: data.seriesGuardadas.map((data) => {
                    return {
                        nomSerie: data,
                    };
                }),
            };
        });

        const jsonData = await registrarIngresoInventario(
            objetoEnvio,
            4,
            almacenSeleccionado
        ); // SE CAMBIO EL CODIGO DOCUMENTO POR EL CAMBIO DE ESQUEMA
        notify(
            jsonData.DesResultado,
            jsonData.CodResultado == 1 ? "success" : "error"
        );
        if (jsonData.CodResultado == 1) {
            await funcionListarTabla();
            closeModal();
        }
    };
    const funcionConfirmarSalidaPorOT = async () => {
        // VALIDACION PARA VER SI REGISTRAR LAS SERIES SOLICITADAS
        const isRegistroIncompleto = movimientoInfo.repuestoDetalle
            .split("~")
            .some((elem) => {
                const concatenadosRepuestos = elem.split("*");
                if (concatenadosRepuestos[4] == 1) {
                    if (concatenadosRepuestos[6]) {
                        return (
                            Number(concatenadosRepuestos[3]) !=
                            Number(concatenadosRepuestos[6].split(",").length)
                        );
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            });

        if (isRegistroIncompleto) {
            notify("Elegir todas las series para los productos", "info");
            return;
        }

        if (!movimientoInfo.codSolicitante) {
            notify("Elegir el solicitante", "info");
            return;
        }
        // FIN VALIDACION

        const jsonData = await registrarSalidaPorOT({
            codPersonaEntrega: parseInt(movimientoInfo.codSolicitante),
            codOrdenTrabajo: movimientoInfo.codOrdenTrabajo,
            comentarioSalidaPedido: movimientoInfo.comentario,
            pedidoDetalle: movimientoInfo.repuestoDetalle
                .split("~")
                .map((data, i) => {
                    const partes = data.split("*");
                    return {
                        codRepuesto: parseInt(partes[0]),
                        cantidad: parseInt(partes[3]),
                        series:
                            partes[4] == 1
                                ? partes[6].split(",").map((data) => {
                                      return {
                                          codSerieRepuesto: data,
                                      };
                                  })
                                : [],
                    };
                }),
        });
        notify(
            jsonData.DesResultado,
            jsonData.CodResultado == 1 ? "success" : "error"
        );
        if (jsonData.CodResultado == 1) {
            closeSalidaOT();
            await funcionListarTabla();
        }
    };


    // FUNCIONES SALIDA POR TRASLADO ALMACEN
    const funcionGenerarSalidaTraslado = async () => {
        const response = await registrarSalidaPorTraslado({
            codAlmacenOrigen: almacenOrigen,
            codAlmacenDestino: almacenDestino,
            comentarioOrigen: comentarioSalida,
            codDocumento: ultimoDocumentoSalida.codDocumento,
            serieDocumento: ultimoDocumentoSalida.serieComprobante,
            correlativoDocumento: ultimoDocumentoSalida.correlativoComprobante,
            transferenciaDetalle: arrProductos
        })
        notify(response.DesResultado,response.CodResultado == 1 ? 'success' : 'error')
        if(response.CodResultado == 1){
            await funcionListarTabla()
            closeModalSalida()
        }
    }
    const funcionAnularSalidaTraslado = async () => {
        const response = await anularSalidaPorTraslado({
            codTransferencia: codigoSalidaTraslado,
            comentarioEliminacion: comentarioAnulacionSalida
        })
        notify(response.DesResultado,response.CodResultado == 1 ? 'success' : 'error')
        if(response.CodResultado == 1){
            
        }
    }
    // --

    // FUNCIONES INGRESO POR TRASLADO ALMACEN  
    const funcionGenerearIngresoTraslado = async () => {
        const response = await registrarIngresoPorTrasladoAlmacen({
            codTransferencia : infoPreIngresoAlmacen.codTransferencia,
            codAlmacenDestino : almacenDestino,
            comentarioDestino : comentarioSalida,
            codDocumento : ultimoDocumentoIngreso.codDocumento,
            serieDocumento : ultimoDocumentoIngreso.serieComprobante,
            correlativoDocumento : ultimoDocumentoIngreso.correlativoComprobante,
            transferenciaDetalle : arrProductos
        })
        notify(response.DesResultado,response.CodResultado == 1 ? 'success' : 'error')
        if(response.CodResultado == 1){
            await funcionListarTabla()
            closeModalSalida()
        }
    }


    return (
        <>
            <ComponenteBloqueo></ComponenteBloqueo>

            <div className="w-full h-full flex flex-col">
                <ContenedorParametros titulo="Movimientos" tablaId="tablaId">
                    <div className="flex items-center">
                        <i className="mr-[10px] far fa-calendar-alt"></i>
                        <DatePickerABX
                            className=""
                            date={startDate}
                            setDate={setStartDate}
                        />
                    </div>

                    <div className="flex items-center">
                        <i className="mr-[10px] far fa-calendar-alt"></i>
                        <DatePickerABX
                            className=""
                            date={endDate}
                            setDate={setEndDate}
                        />
                    </div>

                    <div>
                        <select
                            value={movimientoSeleccionado}
                            onChange={(e) =>
                                setMovimientoSeleccionado(e.target.value)
                            }
                            className={`${classNameInput} `}
                        >
                            {/* <option value={0}>--Seleccione--</option> */}
                            {tipoMovimientos.map((data, i) => (
                                <option key={i + 1} value={data.codMotivo}>
                                    {data.nomMotivo}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <select
                            value={almacenSeleccionado}
                            onChange={(e) =>
                                setAlmacenSeleccionado(e.target.value)
                            }
                            className={`${classNameInput} ${movimientoSeleccionado == 1 ? '' : 'hidden'}`}
                        >
                            {almacenes.map((data, i) => (
                                <option key={i + 1} value={data.codAlmacen}>
                                    {data.nomAlmacen}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div
                        className={`${
                            movimientoSeleccionado == 10 ? "" : "hidden"
                        }`}
                    >
                        <select
                            value={estadoSeleccionado}
                            onChange={(e) =>
                                setEstadoSeleccionado(e.target.value)
                            }
                            className={classNameInput}
                        >
                            <option value={0}>--Todos--</option>
                            {estadosMovimiento.map((data, i) => (
                                <option key={i + 1} value={data.codEstado}>
                                    {data.nomEstado}
                                </option>
                            ))}
                        </select>
                    </div>

                    { [1,6].includes(Number(movimientoSeleccionado)) ? (
                        <BotonNuevo
                            onClick={() => {
                                switch (Number(movimientoSeleccionado)) {
                                    case 1:
                                        setFilasTablaIngresoInventario([]);
                                        openModal();
                                        break;
                                    case 6:
                                        obtenerUltimoDocumentoSalida()

                                        setAlmacenOrigen(0)
                                        setAlmacenDestino(0)
                                        setComentarioSalida('')
                                        setArrProductos([productoDefault])
                                        setSeriesMovimientos([])

                                        openModalSalida()
                                        break;
                                    default:
                                        break;
                                }
                            }}
                        ></BotonNuevo>
                    ) : (
                        ""
                    )}

                    <BotonProcesar onClick={funcionListarTabla}></BotonProcesar>
                </ContenedorParametros>

                <div className="containerScroll mt-7 relative flex-1 overflow-auto">
                    <table id="tablaId" className="tableResponsive">
                        <thead>
                            {
                            movimientoSeleccionado == 1 ?  // INGRESO POR INVENTARIO
                                <tr>
                                    <th>N°</th>
                                    <th>FECHA</th>
                                    <th>DOCUMENTO</th>
                                    <th>PERSONA</th>
                                    <th>MOTIVO</th>
                                    <th>PRODUCTOS</th>
                                    <th>ESTADO</th>
                                    <th></th>
                                </tr>
                            :   movimientoSeleccionado == 10 ? // SALIDA DE ORDEN DE TRABAJO
                                <tr>
                                    <th>N°</th>
                                    <th>FECHA</th>
                                    <th>CÓDIGO</th>
                                    <th>UNIDAD</th>
                                    <th>CONDUCTOR</th>
                                    <th>DETALLE</th>
                                    <th>U.CREACIÓN</th>
                                    <th>ESTADO</th>
                                    <th></th>
                                </tr>
                            :   movimientoSeleccionado == 6 ? //SALIDA POR TRASLADO ALMACEN
                                <tr>
                                    <th>Nº</th>
                                    <th>DOCUMENTO</th>
                                    <th>FECHA ORIGEN</th>
                                    <th>FECHA DESTINO</th>
                                    <th>DOCUMENTO PEDIDO</th>
                                    <th>ALMACÉN ORIGEN</th>
                                    <th>ALMACÉN DESTINO</th>
                                    <th>USUARIO ORIGEN</th>
                                    <th>USUARIO DESTINO</th>
                                    <th>COMENTARIO ORIGEN</th>
                                    <th>COMENTARIO DESTINO</th>
                                    <th>ESTADO</th>
                                    <th></th>
                                </tr>
                            :   movimientoSeleccionado == 7 ? //INGRESO POR TRASLADO ALMACEN
                                <tr>
                                    <th>Nº</th>
                                    <th>DOCUMENTO</th>
                                    <th>FECHA ORIGEN</th>
                                    <th>FECHA DESTINO</th>
                                    <th>ALMACÉN ORIGEN</th>
                                    <th>ALMACÉN DESTINO</th>
                                    <th>USUARIO ORIGEN</th>
                                    <th>USUARIO DESTINO</th>
                                    <th>COMENTARIO ORIGEN</th>
                                    <th>COMENTARIO DESTINO</th>
                                    <th>ESTADO</th>
                                </tr>
                            :
                                <tr>
                                    <th></th>
                                </tr>
                            }
                        </thead>
                        <tbody>
                            {
                                movimientoSeleccionado == 1 ?  // INGRESO POR INVENTARIO
                                    ingresosInventario.length != 0 ? (
                                        ingresosInventario.map((data, i) => {
                                            return (
                                                <tr key={i + 1}>
                                                    <td className="">{i + 1}</td>
                                                    <td
                                                        data-label="Fecha"
                                                        className=" whitespace-nowrap"
                                                    >
                                                        {data.fechaCreacion || "-"}
                                                    </td>
                                                    <td
                                                        data-label="Documento"
                                                        className=" whitespace-nowrap"
                                                    >
                                                        {data.nroDocumento || "-"}
                                                    </td>
                                                    <td
                                                        data-label="Persona"
                                                        className=" whitespace-nowrap"
                                                    >
                                                        {data.nomPersonaCreacion ||
                                                            "-"}
                                                    </td>
                                                    <td
                                                        data-label="Repuestos"
                                                        className=" whitespace-nowrap"
                                                        title={data.nomRepuestos}
                                                    >
                                                        <div className="max-h-40 overflow-hidden text-ellipsis whitespace-nowrap">{data.nomRepuestos || "-"}</div>
                                                    </td>
                                                    <td
                                                        data-label="Motivo"
                                                        className=" whitespace-nowrap"
                                                    >
                                                        {data.nomMotivo || "-"}
                                                    </td>
                                                    <td
                                                        data-label="Estado"
                                                        className="!flex items-center justify-between"
                                                    >
                                                        <div
                                                            className={`text-center margin-0 rounded !text-xs !w-[90px] px-2 py-1 whitespace-nowrap bg-green-600`}
                                                        >
                                                            {capitalLetter(data.nomEstado) || "-"}
                                                        </div>
                                                    </td>
                                                    <td
                                                        data-label="Opciones"
                                                        className=" whitespace-nowrap"
                                                    >
                                                        <button
                                                            className="rounded px-2 h-[30px] text-xs bg-[#155bb5]"
                                                            onClick={(e) => {
                                                                openModalDetallado();
                                                                setDetalleMovimiento(
                                                                    data.repuestoDetalle.split(
                                                                        "~"
                                                                    )
                                                                );
                                                            }}
                                                        >
                                                            <i
                                                                className="fa fa-search"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={7} className="text-center">
                                                No hay información para mostrar con
                                                los parametros seleccionados...
                                            </td>
                                        </tr>
                                    )
                                : movimientoSeleccionado == 10 ? ( // SALIDA DE ORDEN DE TRABAJO
                                    diagnosticosTaller.length != 0 ? (
                                        diagnosticosTaller
                                            .filter((e) => e.repuestoDetalle)
                                            .map((data, i) => {
                                                // FILTRANDO SOLO CUANDO TENGA "REPUESTO DETALLE" (SE EXCLUYE LOS SERVICIOS)
                                                const concatenadoProductos =
                                                    data.repuestoDetalle
                                                        .split("~")
                                                        .map((e) => {
                                                            const partes =
                                                                e.split("*");
                                                            return `(${partes[3]}) ${partes[1]}`;
                                                        })
                                                        .join(", ") || "-";
                                                return (
                                                    <tr key={i + 1}>
                                                        <td className="">
                                                            {i + 1}
                                                        </td>
                                                        <td
                                                            data-label="Fecha"
                                                            className="whitespace-nowrap"
                                                        >
                                                            {data.fechaOrdenTrabajo ||
                                                                "-"}
                                                        </td>
                                                        <td
                                                            data-label="Código"
                                                            className="whitespace-nowrap"
                                                        >
                                                            {data.numDocumentoOT ||
                                                                "-"}
                                                        </td>
                                                        <td
                                                            data-label="Unidad"
                                                            className="whitespace-nowrap"
                                                        >
                                                            {data.unidad || "-"}
                                                        </td>
                                                        <td
                                                            data-label="Conductor"
                                                            className="whitespace-nowrap"
                                                        >
                                                            {data.nomPersonaCreacion ||
                                                                "-"}
                                                        </td>
                                                        <td
                                                            data-label="Detalle"
                                                            title={
                                                                concatenadoProductos
                                                            }
                                                            className="text-left whitespace-nowrap max-w-[300px] overflow-hidden text-ellipsis"
                                                        >
                                                            {concatenadoProductos}
                                                        </td>
                                                        <td
                                                            data-label="U.Creación"
                                                            className="whitespace-nowrap"
                                                        >
                                                            {data.nomUsuarioCreacion ||
                                                                "-"}
                                                        </td>
                                                        {/* <td className='whitespace-nowrap'><label className={`${estadosSalidaOrdenTrabajo[data.codEstadoSuministroAlmacen]} text-xs px-2 rounded`}>{data.nomEstadoSuministroAlmacen || '-'}</label></td> */}
                                                        <td
                                                            data-label="Estado"
                                                            className="text-center !flex items-center justify-between"
                                                        >
                                                            <div
                                                                className={`rounded !text-xs !w-[90px] px-2 py-1 whitespace-nowrap ${
                                                                    estadosSalidaOrdenTrabajo[
                                                                        data
                                                                            .codEstadoSuministroAlmacen
                                                                    ]
                                                                }`}
                                                            >
                                                                {capitalLetter(data.nomEstadoSuministroAlmacen) ||
                                                                    "-"}
                                                            </div>
                                                        </td>
                                                        <td
                                                            data-label="Opciones"
                                                            className="whitespace-nowrap"
                                                        >
                                                            {data.codEstadoSuministroAlmacen ==
                                                            9 ? (
                                                                <button
                                                                    onClick={() => {
                                                                        openSalidaOT();
                                                                        setMovimientoInfo(
                                                                            Object.assign(
                                                                                {},
                                                                                movimientoDefault,
                                                                                data
                                                                            )
                                                                        );
                                                                    }}
                                                                    className="!h-[20px] text-xs px-1 rounded bg-green-600"
                                                                >
                                                                    <i
                                                                        className="fa fa-check"
                                                                        aria-hidden="true"
                                                                    ></i>
                                                                </button>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                    ) : (
                                        <tr>
                                            <td colSpan={8} className="text-center">
                                                No hay información con los
                                                parametros seleccionados...
                                            </td>
                                        </tr>
                                    )
                                )
                                : movimientoSeleccionado == 6 ?     // SALIDA POR TRASLADO
                                    listadoSalidasPorTraslado.length != 0 ?
                                        listadoSalidasPorTraslado.map((data,i) => {
                                            return(
                                                <tr key={i+1}>
                                                    <td>{i+1}</td>
                                                    <td>{data.documentoPedidoSalida || '-'}</td>
                                                    <td>{data.fechaHoraOrigen || '-'}</td>
                                                    <td>{data.fechaHoraDestino || '-'}</td>
                                                    <td>{data.documentoPedido || '-'}</td>
                                                    <td>{data.nomAlmacenOrigen || '-'}</td>
                                                    <td>{data.nomAlmacenDestino || '-'}</td>
                                                    <td>{data.nomUsuarioOrigen || '-'}</td>
                                                    <td>{data.nomUsuarioDestino || '-'}</td>
                                                    <td>{data.comentarioOrigen || '-'}</td>
                                                    <td>{data.comentarioDestino || '-'}</td>
                                                    <td><div className={`${data.codEstado == 21 ? 'bg-green-600' : data.codEstado == 9 ? 'bg-gray-600' : 'bg-yellow-600'} text-center rounded text-xs p-1`}>{capitalLetter(data.nomEstado) || '-'}</div></td>
                                                    <td>{data.codEstado == 9 ? <button onClick={() => {openModalAnularSalida();setComentarioAnulacionSalida('');setCodigoSalidaTraslado(data.codTransferencia)}} className="bg-red-600 h-[25px] w-[25px] rounded text-xs"><i className="fas fa-trash "></i></button> : <></>}</td>
                                                </tr>
                                            )
                                        })
                                    :
                                        <tr><td className="text-center" colSpan={12}>No hay información con los parametros seleccionados...</td></tr>
                                : movimientoSeleccionado == 7 ?     // INGRESO POR TRASLADO
                                    listaIngresos.length != 0 ?
                                        listaIngresos.map((data,i) => {
                                            return(
                                                <tr key={i+1}>
                                                    <td>{i+1}</td>
                                                    <td>
                                                        {
                                                            data.codEstado == 9 ?
                                                                <a
                                                                    className="text-blue-500 hover:underline"
                                                                    onClick={async () => {
                                                                        await obtenerUltimoDocumentoIngreso()

                                                                        const response = await listarInfoMovimiento(data.codTransferencia)
                                                                        setAlmacenOrigen(response.cabeceraTransferenciaRespuesta.codAlmacenOrigen)
                                                                        await listarProductos(response.cabeceraTransferenciaRespuesta.codAlmacenOrigen)     // LISTA PRODUCTOS PARA EL COMBO DE PRODCUTOS
                                                                        setAlmacenDestino(response.cabeceraTransferenciaRespuesta.codAlmacenDestino)
                                                                        setArrProductos(response.detalleTransferenciaRespuesta.map(e => ({
                                                                            codProducto: Number(e.codRepuesto),
                                                                            serieProducto: e.registraSerie,
                                                                            cantidadProducto: Number(e.cantidadRepuesto),
                                                                            listaSeries: e.codSerieRepuestos.split(',').map(elem => ({codSerieProducto: elem}))     // OJO: VER SI SE VA A MOSTRAR LAS SERIES
                                                                        })))
                                                                        setComentarioSalida('')
                                                                        setInfoPreIngresoAlmacen(data)

                                                                        openModalSalida()
                                                                    }}
                                                                >{data.documentoPedidoSalida || '-'}</a>
                                                            : data.documentoPedidoIngreso || '-'
                                                        }
                                                    </td>
                                                    <td>{data.fechaHoraOrigen || '-'}</td>
                                                    <td>{data.fechaHoraDestino || '-'}</td>
                                                    <td>{data.nomAlmacenOrigen || '-'}</td>
                                                    <td>{data.nomAlmacenDestino || '-'}</td>
                                                    <td>{data.nomUsuarioOrigen || '-'}</td>
                                                    <td>{data.nomUsuarioDestino || '-'}</td>
                                                    <td>{data.comentarioOrigen || '-'}</td>
                                                    <td>{data.comentarioDestino || '-'}</td>
                                                    <td><div className={`${data.codEstado == 21 ? 'bg-green-600' : data.codEstado == 9 ? 'bg-gray-600' : 'bg-yellow-600'} text-center rounded text-xs p-1`}>{capitalLetter(data.nomEstado) || '-'}</div></td>
                                                </tr>
                                            )
                                        })
                                    :
                                        <tr><td className="text-center" colSpan={11}>No hay información con los parametros seleccionados...</td></tr>
                                : 
                                (
                                    <tr>
                                        <td className="text-center">
                                            Seleccionar todos los parametros y dar
                                            click en el boton procesar...
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <Modal
                isOpen={isOpenModalSalida}
                title={movimientoSeleccionado == 7 ? `Ingreso por traslado almacén [${infoPreIngresoAlmacen.documentoPedidoSalida}]` : movimientoSeleccionado == 6 ? 'Salida por traslado almacén' : ''}
                closeModal={closeModalSalida}
                action={async () => {
                    if(movimientoSeleccionado == 7){
                        await funcionGenerearIngresoTraslado()
                    }else{
                        await funcionGenerarSalidaTraslado()
                    }
                }}
            >
                <div className={` flex flex-col gap-4 w-[40vw] lg:w-full p-4`}>
                    <div className={`${movimientoSeleccionado == 7 ? 'pointer-events-none' : ''} flex flex-col gap-4`}>
                        <div className="flex justify-end">
                            <div className="w-1/3 grid grid-cols-3 gap-2">
                                <span>Código:</span>
                                <input value={`${movimientoSeleccionado == 7 ? ultimoDocumentoIngreso.nroDocumento : (ultimoDocumentoSalida?.nroDocumento || '')}`} type="text" className={`${classNameInput} col-span-2`} disabled />
                                <span>Fecha:</span>
                                <input defaultValue={dateToString(new Date())} type="text" className={`${classNameInput} col-span-2`} disabled />
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <div className="w-1/2 flex flex-col gap-2">
                                <span>Almacén origen</span>
                                <select 
                                    value={almacenOrigen} 
                                    onChange={e => {
                                        e.target.value != 0 ? listarProductos(e.target.value) : setListaProductos([])
                                        setAlmacenOrigen(Number(e.target.value))
                                        e.target.value == almacenDestino && setAlmacenDestino(0)
                                        setArrProductos([productoDefault])
                                    }} 
                                    className={classNameInput}
                                >
                                    <option value="0">-- Seleccione --</option>
                                    {
                                        almacenesPorUsuario.filter(e => e.codAlmacen != almacenDestino).map((data,i) => (
                                            <option key={i+1} value={data.codAlmacen}>{data.nomAlmacen}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="w-1/2 flex flex-col gap-2">
                                <span>Almacén destino</span>
                                <select 
                                    value={almacenDestino} 
                                    onChange={e => {
                                        setAlmacenDestino(Number(e.target.value))
                                        e.target.value == almacenDestino && setAlmacenOrigen(0)
                                    }} 
                                    className={classNameInput}
                                >
                                    <option value="0">-- Seleccione --</option>
                                    {
                                        almacenesPorUsuario.filter(e => e.codAlmacen != almacenOrigen).map((data,i) => (
                                            <option key={i+1} value={data.codAlmacen}>{data.nomAlmacen}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        <div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="w-[50px]">Nº</th>
                                        <th>PRODUCTO</th>
                                        <th className="w-[150px]">CANTIDAD</th>
                                        <th className="w-[20px]"></th>
                                        <th className="w-[20px]"></th>
                                        <th className="w-[20px]"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        arrProductos.map((data,i) => {
                                            return (
                                                <tr key={i+1}>
                                                    <td>{i+1}</td>
                                                    <td>
                                                        <select 
                                                            value={data.codProducto} 
                                                            onChange={e => {
                                                                setArrProductos(valAnterior => {
                                                                    const arrCopy = [...valAnterior]
                                                                    arrCopy[i].codProducto = Number(e.target.value)
                                                                    arrCopy[i].serieProducto = listaProductos.find(elem => elem.codRepuesto == e.target.value)?.registraSerie
                                                                    arrCopy[i].listaSeries = []
                                                                    arrCopy[i].cantidadProducto = 0
                                                                    return arrCopy
                                                                })
                                                                // listarRepuestoCodigos()
                                                            }}
                                                            className={classNameInput}
                                                        >
                                                            <option value="0">-- Seleccione --</option>
                                                            {
                                                                listaProductos.map((data,j) => <option key={j+1} value={data.codRepuesto}>{data.nombreRepuesto} | (Stock: {data.stockAlmacen})</option>)
                                                            }
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input 
                                                            value={data.cantidadProducto}
                                                            onChange={e => {
                                                                setArrProductos(valAnterior => {
                                                                    const arrCopy = [...valAnterior]
                                                                    arrCopy[i].cantidadProducto = Number(e.target.value)
                                                                    return arrCopy
                                                                })
                                                            }}
                                                            type="number" 
                                                            min={0}
                                                            className={classNameInput} 
                                                        />
                                                    </td>
                                                    <td>
                                                        {
                                                            data.serieProducto ? 
                                                                <i 
                                                                    onClick={() => {
                                                                        listarRepuestoCodigos(data.codProducto,almacenOrigen)
                                                                        setSeriesMovimientos(
                                                                            data.listaSeries.length == 0 ?
                                                                                new Array(Number(data.cantidadProducto)).fill(0)
                                                                            : data.listaSeries.map(e => Number(e.codSerieProducto))
                                                                        )
                                                                        openModalSeriesMovimiento();
                                                                        setIndiceProducto(i)
                                                                    }} 
                                                                    className="fas fa-bars text-lg"
                                                                    ></i> 
                                                            : <></>
                                                        }
                                                        
                                                    </td>
                                                    <td>
                                                        {
                                                            movimientoSeleccionado != 7 ?
                                                                <button 
                                                                    className="w-[25px] h-[25px] bg-red-600 rounded"
                                                                    onClick={() => 
                                                                        arrProductos.length != 1 ?
                                                                            setArrProductos(valAnterior => {
                                                                                const arrCopia = [...valAnterior]
                                                                                arrCopia.splice(i,1)
                                                                                return arrCopia
                                                                            })
                                                                        : setArrProductos([productoDefault])
                                                                    } 
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            : <></>
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            (i == arrProductos.length - 1) && (movimientoSeleccionado != 7) ?
                                                            <button 
                                                                className="w-[25px] h-[25px] bg-green-600 rounded"
                                                                onClick={() => setArrProductos(valAnterior => {
                                                                    return  [...valAnterior,productoDefault]
                                                                })} 
                                                            >
                                                                <i className="fas fa-plus"></i>
                                                            </button>
                                                            : <></>
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <span>Comentario:</span>
                        <textarea 
                            value={comentarioSalida} 
                            onChange={e => setComentarioSalida(e.target.value)} 
                            placeholder="(Comentario)" 
                            className={`${classNameInput} h-[100px]`}
                        ></textarea>
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={isOpenModalSeriesMovimiento}
                title={'Elegir series'}
                closeModal={closeModalSeriesMovimiento}
                action={() => {
                    if(!seriesMovimiento.includes(0)){
                        setArrProductos(valorAnterior => {
                            const arrCopia = [...valorAnterior]
                            const elementoModificar = arrCopia[indiceProducto]
                            elementoModificar.listaSeries = seriesMovimiento.map(valor => ({codSerieProducto: valor}))
                            return arrCopia
                        })
                        closeModalSeriesMovimiento()
                    }else{
                        notify('Elegir todas las series','info')
                    }
                }}
            >
                <div >
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Nº</th>
                                <th>SERIE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Array.from({length:arrProductos[indiceProducto]?.cantidadProducto}).map((_,i) => {
                                    return(
                                        <tr key={i+1}>
                                            <td>{i+1}</td>
                                            <td>
                                                <select 
                                                    value={seriesMovimiento[i]} 
                                                    onChange={e => {
                                                        setSeriesMovimientos(valAnterior => {
                                                            const arrCopia = [...valAnterior]
                                                            arrCopia[i] = Number(e.target.value)
                                                            return arrCopia
                                                        })
                                                    }} 
                                                    className={classNameInput}
                                                >
                                                    <option value="0">-- Seleccione --</option>
                                                    {
                                                        repuestosCodigos.map((data,j) => {
                                                            return <option key={j+1} value={data.codAlmacenRepuestoSerie}>{data.serieRepuesto || '-'}</option>
                                                        })
                                                    }
                                                </select>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </Modal>

            <Modal
                isOpen={isOpen}
                closeModal={closeModal}
                title="Ingreso por inventario"
                action={funcionRegistroMovimiento}
            >
                <div className="flex items-center flex-col justify-center w-[800px] lg:w-full lg:flex-grow p-2 gap-5">
                    <fieldset className="w-full h-[100px] flex flex-col items-center justify-center gap-2 relative border rounded">
                        <div className="absolute top-0 left-5 bg-[#2f3134] -translate-y-1/2 px-2">
                            Búsqueda de producto
                        </div>
                        <div className="w-full flex items-center justify-center gap-3 p-10">
                            <i className="fa fa-search" aria-hidden="true"></i>
                            <AutoCompleteV2
                                listaOpciones={productos.map((data) => {
                                    return {
                                        text:
                                            data.nombreRepuesto +
                                            " - " +
                                            (data.marca || "sin marca"),
                                        value: data.codRepuesto,
                                    };
                                })}
                                cambiarOpcionSeleccionada={
                                    funcionAgregarElemento
                                }
                            ></AutoCompleteV2>
                        </div>
                    </fieldset>

                    <fieldset className="w-full min-h-[100px] flex flex-col items-center justify-center gap-2 relative border lg:border-0 rounded p-5 lg:p-0">
                        <div className="max-h-[400px] lg:max-h-full w-full overflow-auto containerScroll">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="text-left">NOMBRE</th>
                                        <th className="text-left lg:hidden">
                                            SERIES
                                        </th>
                                        <th>CANTIDAD</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filasTablaIngresoInventario.length != 0 ? (
                                        filasTablaIngresoInventario.map(
                                            (data, i) => {
                                                return (
                                                    <tr key={i + 1}>
                                                        <td>
                                                            {
                                                                data.nombreRepuesto
                                                            }
                                                        </td>
                                                        <td className="text-center lg:hidden">
                                                            <div
                                                                title={data.seriesGuardadas.join(
                                                                    ", "
                                                                )}
                                                                className="max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap"
                                                            >
                                                                {data.seriesGuardadas.join(
                                                                    ", "
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="text-center w-[100px]">
                                                            <input
                                                                value={
                                                                    data.cantidadProductos
                                                                }
                                                                type="number"
                                                                min={0}
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    editarCantidadFilasTablaInventario(
                                                                        data.codRepuesto,
                                                                        e.target
                                                                            .value
                                                                    );
                                                                }}
                                                                className={`${classNameInput} w-[100px]`}
                                                            />
                                                        </td>
                                                        <td className="text-center w-[50px]">
                                                            {data.registraSerie ? (
                                                                <i
                                                                    className="fa fa-barcode text-3xl"
                                                                    aria-hidden="true"
                                                                    onClick={() => {
                                                                        openModalSeries();
                                                                        setCodigoProdSeleccionadoSerie(
                                                                            data.codRepuesto
                                                                        );
                                                                        setCantidadProductosSeries(
                                                                            2
                                                                        );
                                                                    }}
                                                                ></i>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </td>
                                                        <td className="text-center"></td>
                                                    </tr>
                                                );
                                            }
                                        )
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={5}
                                                className="text-center"
                                            >
                                                No hay información...
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </fieldset>
                </div>
            </Modal>

            <Modal
                title={"Registrar series"}
                isOpen={isOpenSeries}
                closeModal={() => {
                    setFilasTablaIngresoInventario((datosAnteriores) => {
                        const arrayTemporal = [...datosAnteriores];
                        const elementoModificar = arrayTemporal.find(
                            (e) => e.codRepuesto == codigoProdSeleccionadoSerie
                        );
                        const elementoModificado = { ...elementoModificar };
                        elementoModificado.seriesGuardadas = [];
                        const indiceModificado = arrayTemporal.findIndex(
                            (e) => e.codRepuesto == codigoProdSeleccionadoSerie
                        );
                        arrayTemporal[indiceModificado] = elementoModificado;

                        return arrayTemporal;
                    });
                    closeModalSeries();
                }}
                action={() => {
                    const elemento = filasTablaIngresoInventario.find(
                        (e) => e.codRepuesto == codigoProdSeleccionadoSerie
                    );
                    const seriesValidas = elemento.seriesGuardadas.filter((e) =>
                        e.trim()
                    );

                    if (seriesValidas.length != elemento.cantidadProductos) {
                        notify("Completar todos los campos", "error");
                    } else {
                        closeModalSeries();
                    }
                }}
            >
                <div className="p-2 overflow-auto max-h-[400px] containerScroll">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Nº</th>
                                <th>SERIE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({
                                length:
                                    filasTablaIngresoInventario.find(
                                        (e) =>
                                            e.codRepuesto ==
                                            codigoProdSeleccionadoSerie
                                    )?.cantidadProductos || 0,
                            }).map((data, i) => {
                                return (
                                    <tr key={i + 1}>
                                        <td className="text-center">{i + 1}</td>
                                        <td className="text-center">
                                            <input
                                                value={
                                                    filasTablaIngresoInventario.find(
                                                        (e) =>
                                                            e.codRepuesto ==
                                                            codigoProdSeleccionadoSerie
                                                    )?.seriesGuardadas[i] || ""
                                                }
                                                onChange={(e) =>
                                                    agregarSeriesAProducto(
                                                        codigoProdSeleccionadoSerie,
                                                        i,
                                                        e.target.value
                                                    )
                                                }
                                                className={`${classNameInput} w-[150px]`}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Modal>

            <Modal
                title={"Detallado movimiento"}
                isOpen={isOpenDetallado}
                closeModal={closeModalDetallado}
                validButton={{}}
            >
                <div className="w-[800px] lg:w-full max-h-[300px] overflow-auto p-5 containerScroll box-border">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Nº</th>
                                <th>PRODUCTO</th>
                                <th>C.ANTERIOR</th>
                                <th>C.INGRESADA</th>
                                <th>C.ACTUAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {detalleMovimiento.length != 0
                                ? detalleMovimiento.map((data, i) => {
                                      const partes = data.split("*");
                                      return (
                                          <tr key={i + 1}>
                                              <td className="text-center">
                                                  {i + 1}
                                              </td>
                                              <td className="text-center">
                                                  {partes[0]}
                                              </td>
                                              <td className="text-center">
                                                  {partes[4]}
                                              </td>
                                              <td className="text-center">
                                                  {partes[3]}
                                              </td>
                                              <td className="text-center">
                                                  {partes[5]}
                                              </td>
                                          </tr>
                                      );
                                  })
                                : ""}
                        </tbody>
                    </table>
                </div>
            </Modal>

            <Modal
                title={"Salida de almacén por OT"}
                isOpen={isOpenSalidaOT}
                action={funcionConfirmarSalidaPorOT}
                closeModal={closeSalidaOT}
            >
                <div className="w-[700px] lg:w-full flex flex-col gap-4 px-4">
                    <fieldset className="border rounded p-4">
                        <legend>Datos OT</legend>
                        <div className="grid grid-cols-2 lg:grid-cols-1 gap-[100px] lg:gap-2">
                            <div className="grid grid-cols-3 gap-2">
                                <i
                                    className="col-span-1 fa fa-calendar text-sm"
                                    aria-hidden="true"
                                ></i>
                                <input
                                    defaultValue={
                                        movimientoInfo.fechaOrdenTrabajo
                                    }
                                    disabled
                                    className={`${classNameInput} col-span-2`}
                                />
                                <i
                                    className="col-span-1 fa fa-bus text-sm"
                                    aria-hidden="true"
                                ></i>
                                <select
                                    defaultValue={movimientoInfo.codUnidad}
                                    disabled
                                    className={`${classNameInput} col-span-2`}
                                >
                                    {unidadesActivas.map((data, i) => (
                                        <option
                                            key={i + 1}
                                            value={data.codUnidad}
                                        >
                                            {data.nomUnidad}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="grid grid-cols-3 gap-2">
                                <span className="col-span-1">Código</span>
                                <input
                                    defaultValue={movimientoInfo.numDocumentoOT}
                                    disabled
                                    className={`${classNameInput} col-span-2`}
                                />
                                <i
                                    className="col-span-1 fa fa-user text-sm"
                                    aria-hidden="true"
                                ></i>
                                <select
                                    defaultValue={
                                        movimientoInfo.codPersonaConductor
                                    }
                                    disabled
                                    className={`${classNameInput} col-span-2`}
                                >
                                    {conductores.map((data, i) => (
                                        <option
                                            key={i + 1}
                                            value={data.codPersona}
                                        >
                                            {data.nomPersona}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset className="border rounded p-4">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Nº</th>
                                    <th>ARTÍCULO</th>
                                    <th>CANTIDAD</th>
                                    <th>SERIE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {movimientoInfo.repuestoDetalle
                                    ?.split("~") // SEPARA LOS PRODUCTOS
                                    .map((data, i) => {
                                        const partes = data.split("*"); // SEPARA LAS CARACTERISTICAS DE LOS PRODUCTOS
                                        /*
                                            partes -> codProducto*nomProducto*descripcionProducto*cantidadSolicitada*tieneSerie*_*seriesConcatenadasConComas
                                        */
                                        const seriesRegistradas = partes[6]
                                            ? partes[6]
                                                  .split(",")
                                                  .reduce(
                                                      (
                                                          acumulador,
                                                          data,
                                                          index
                                                      ) => {
                                                          acumulador[index] =
                                                              data;
                                                          return acumulador;
                                                      },
                                                      {}
                                                  )
                                            : {};

                                        return (
                                            <tr key={i + 1}>
                                                <td className="text-center">
                                                    {i + 1}
                                                </td>
                                                <td className="text-center">
                                                    {partes[1]}
                                                </td>
                                                <td className="text-center">
                                                    {partes[3]}
                                                </td>
                                                <td className="text-center">
                                                    {partes[4] == 1 ? (
                                                        <i
                                                            onClick={() => {
                                                                setCodigoProdSeleccionadoSerie(
                                                                    partes[0]
                                                                );
                                                                setSeriesModalSalida(
                                                                    seriesRegistradas
                                                                );
                                                                openModalSeriesSalida();
                                                                listarRepuestoCodigos(
                                                                    partes[0],
                                                                    almacenSeleccionado,
                                                                    1,
                                                                ); // PARA TRAER LA LISTA DE SERIES DE LOS NEUMATICOS
                                                            }}
                                                            className="fa fa-barcode"
                                                            aria-hidden="true"
                                                        ></i>
                                                    ) : (
                                                        ""
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </fieldset>
                    <fieldset className="border rounded p-4">
                        <legend>Comentario</legend>
                        <textarea
                            placeholder="(Comentario)"
                            value={movimientoInfo.comentario}
                            onChange={(e) =>
                                editarValorMovimientoInfo(
                                    "comentario",
                                    e.target.value
                                )
                            }
                            className={`${classNameInput} h-[80px] p-2`}
                        ></textarea>
                    </fieldset>
                    <fieldset className="border rounded p-4">
                        <legend>Datos solicitante</legend>
                        <div className="flex gap-4 items-center">
                            <i
                                className="col-span-1 fa fa-user text-sm"
                                aria-hidden="true"
                            ></i>
                            <select
                                className={classNameInput}
                                value={movimientoInfo.codSolicitante}
                                onChange={(e) =>
                                    editarValorMovimientoInfo(
                                        "codSolicitante",
                                        e.target.value
                                    )
                                }
                            >
                                <option value={0}>--Seleccione--</option>
                                {personasTaller.map((data, i) => (
                                    <option key={i + 1} value={data.codPersona}>
                                        {data.nomPersona}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </fieldset>
                </div>
            </Modal>

            <Modal
                title={"Series salida producto"}
                isOpen={isOpenModalSeriesSalida}
                closeModal={closeModalSeriesSalida}
                action={() => {
                    const series = Object.values(seriesModalSalida);
                    const seriesConcatenadas = series.join(",");
                    let cantidadSeries = 0;
                    const repuestoDetalleModificado =
                        movimientoInfo.repuestoDetalle
                            ?.split("~")
                            .map((data, i) => {
                                const partes = data.split("*");
                                if (partes[0] == codigoProdSeleccionadoSerie) {
                                    cantidadSeries = partes[3];
                                    if (partes[6]) {
                                        partes[6] = seriesConcatenadas;
                                        return partes.join("*");
                                    } else {
                                        return data + "*" + seriesConcatenadas;
                                    }
                                } else {
                                    return data;
                                }
                            })
                            .join("~");

                    if (cantidadSeries == series.length) {
                        editarValorMovimientoInfo(
                            "repuestoDetalle",
                            repuestoDetalleModificado
                        );
                        notify("Series agregadas correctamente", "success");
                        closeModalSeriesSalida();
                    } else {
                        notify(
                            "El numero de series registradas no coincide con el numero de repuestos",
                            "error"
                        );
                    }
                }}
            >
                <div className="w-full p-5 max-h-[200px] overflow-auto containerScroll flex justify-center">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="text-center">Nº</th>
                                <th className="text-center">SERIE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({
                                length: Number(
                                    movimientoInfo.repuestoDetalle
                                        ?.split("~")
                                        .find(
                                            (e) =>
                                                e?.split("*")[0] ==
                                                codigoProdSeleccionadoSerie
                                        )
                                        ?.split("*")[3]
                                ),
                            }).map((_, i) => {
                                return (
                                    <tr key={i + 1}>
                                        <td>{i + 1}</td>
                                        <td>
                                            {/* <input 
                                                    value={seriesModalSalida[i]} 
                                                    onChange={e => setSeriesModalSalida(valoresAnteriores => {
                                                        return {
                                                            ...valoresAnteriores,
                                                            [i]: e.target.value
                                                        }
                                                    })} 
                                                    className={classNameInput} 
                                                    type='text' 
                                                /> */}
                                            <select
                                                className={classNameInput}
                                                value={seriesModalSalida[i]}
                                                onChange={(e) => {
                                                    if (
                                                        Object.values(
                                                            seriesModalSalida
                                                        ).some(
                                                            (elem) =>
                                                                elem ==
                                                                e.target.value
                                                        )
                                                    ) {
                                                        notify(
                                                            "La serie elegida ya fue seleccionada",
                                                            "info"
                                                        );
                                                    } else {
                                                        setSeriesModalSalida(
                                                            (
                                                                valoresAnteriores
                                                            ) => {
                                                                return {
                                                                    ...valoresAnteriores,
                                                                    [i]: e
                                                                        .target
                                                                        .value,
                                                                };
                                                            }
                                                        );
                                                    }
                                                }}
                                            >
                                                <option value="0">
                                                    --Seleccione--
                                                </option>
                                                {repuestosCodigos
                                                    .filter(
                                                        (e) =>
                                                            !Object.values(
                                                                seriesModalSalida
                                                            )
                                                                .filter(
                                                                    (elem) =>
                                                                        elem !=
                                                                        seriesModalSalida[
                                                                            i
                                                                        ]
                                                                )
                                                                .includes(
                                                                    e.serieRepuesto
                                                                )
                                                    )
                                                    .map((data, i) => (
                                                        <option
                                                            key={i + 1}
                                                            value={
                                                                data.serieRepuesto
                                                            }
                                                        >
                                                            {data.serieRepuesto}
                                                        </option>
                                                    ))}
                                            </select>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Modal>

            <Modal
                isOpen={isOpenModalAnularSalida}
                title={'Anular tranferencia'}
                action={funcionAnularSalidaTraslado}
                closeModal={closeModalAnularSalida}
            >
                <div className="flex flex-col gap-4 p-4 w-[400px] items-center">
                    <h1>¿Está seguro de anular la salida?</h1>
                    <textarea value={comentarioAnulacionSalida} onChange={e => setComentarioAnulacionSalida(e.target.value)} className={`${classNameInput} h-[100px] px-2`} placeholder="(Comentario)"></textarea>
                </div>
            </Modal>
        </>
    );
};
